import axios from 'axios'
import useJwt from '@core/auth/jwt/useJwt'
import { extend } from 'vee-validate'
import { required, min, max } from 'vee-validate/dist/rules'

const { jwt } = useJwt(axios, {})
const token = jwt.getToken()

export const credentialAxios = axios.create({
  headers: { Authorization: `Bearer ${token}` },
  baseURL: process.env.VUE_APP_BASE_URL_KOMTIM,
})

credentialAxios.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 403) {
      const message = error.response.data?.meta?.message || ''
      // Cek error pin
      if (message.toLowerCase().includes('pin')) {
        return Promise.reject(error)
      }
      // Jika bukan pin, redirect
      window.location = '/unauthenticated'
    }
    return Promise.reject(error)
  },
)

extend('required', {
  ...required,
  message: field => {
    const messages = {
      'Username/Email': 'Username/Email tidak boleh kosong',
      Password: 'Password tidak boleh kosong',
      Kategori: 'Silakan pilih salah satu kategori',
    }
    return messages[field] || `${field} wajib diisi`
  },
})
extend('min', {
  ...min,
  message: '{_field_} minimal {length} karakter',
})
extend('max', {
  ...max,
  message: '{_field_} maksimal {length} karakter',
})

export function normalizeUrl(url) {
  if (!url) return '#'
  if (/^https?:\/\//i.test(url)) return url
  return `https://${url}`
}

// Custom Validations
export const platformName = extend('platform_name', {
  validate: value => /^[a-zA-Z0-9 .-]{3,}$/.test(value),
  message: 'Nama platform wajib diisi (Min.3 karakter)',
})
export const platformUrl = extend('platform_url', {
  validate: value => /^(https?:\/\/)?([\w\d-]+\.)+[\w-]{2,}(\/.*)?$/.test(value),
  message: 'Format URL tidak valid',
})
export const maxCustom = extend('max_custom', {
  params: ['length'],
  validate(value, { length: maxlength }) {
    return !value || value.length <= maxlength
  },
  message: 'Maksimal {length} karakter',
})

// UI Config
const defaultTdClass = 'py-1 align-middle'
const defaultThStyle = {
  whiteSpace: 'nowrap',
  textTransform: 'none',
  color: '#333333',
  fontSize: '14px',
}
export const FIELDS_CREDENTIAL = [
  {
    key: 'platform',
    label: 'Nama Platform',
    tdClass: defaultTdClass,
    thStyle: defaultThStyle,
  },
  {
    key: 'email',
    label: 'Username/Email',
    tdClass: defaultTdClass,
    thStyle: defaultThStyle,
  },
  {
    key: 'password',
    label: 'Password',
    tdClass: defaultTdClass,
    thStyle: defaultThStyle,
  },
  {
    key: 'note',
    label: 'Catatan',
    tdClass: defaultTdClass,
    thStyle: defaultThStyle,
  },
  {
    key: 'action',
    label: 'Aksi',
    tdClass: `${defaultTdClass} text-right`,
    thStyle: defaultThStyle,
  },
]

export const CATEGORIES_CREDENTIAL = [
  { value: 'Tech', label: 'Tech' },
  { value: 'Mitra Bisnis', label: 'Mitra Bisnis' },
  { value: 'Product', label: 'Product' },
  { value: 'Operasional', label: 'Operasional' },
  { value: 'Office', label: 'Office' },
  { value: 'Lainnya', label: 'Lainnya' },
]
